module.exports = __webpack_public_path__ + "img/6.48eec70d.png";